import { I4BCellType, I4BColumnConfiguration } from './configurations';
import { I4BBasicColumn, I4BColumn, I4BSchedulersButtonColumn, I4BStatusColumn, TotalColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { I4BColumnHeader, I4BGrid, I4BGridOptions, SchedulersGridData } from './models';
import { I4BColumnOptions } from './options';

export const GET_DEFAULT_SCHEDULERS_COLUMNS_FOR_SCHEDULERS_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => [
  new I4BBasicColumn(
    { displayName: 'NAME' },
    {
      id: 'name',
      isDefault: true,
      sortProperty: 'name',
      concept: I4bCellConcept.SCHEDULERS,
      isLink: true,
      cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigate' } }
    },
    { order: 1 }
  ),

  new I4BBasicColumn(
    { displayName: 'COMMAND' },
    {
      id: 'command',
      isDefault: true,
      sortProperty: 'command',
      cell: { type: I4BCellType.BASIC },
      concept: I4bCellConcept.SCHEDULERS
    },
    { order: 2 }
  ),

  new I4BStatusColumn(
    { displayName: 'STATUS' },
    {
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.STATUS',
      id: 'status',
      isDefault: true,
      concept: I4bCellConcept.SCHEDULERS,
      width: 150,
      cell: {
        type: I4BCellType.TRANSLATED_CELL,
        options: {
          withStatusPadding: true,
          class: {
            active: { color: '#262836', 'background-color': 'rgba(164, 255, 0, 0.1)', padding: '9px' },
            disabled: { color: '#262836', 'background-color': 'rgba(255, 0, 99, 0.1)', padding: '9px' }
          }
        }
      }
    },
    {
      order: 3
    }
  ),
  new I4BBasicColumn(
    {
      displayName: 'CRON',
      enableSorting: false
    },
    {
      id: 'cron',
      sortProperty: 'cron',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.SCHEDULER_CRON',
      concept: I4bCellConcept.SCHEDULERS,
      width: 140,
      isDefault: true
    },
    { order: 4 }
  ),
  new I4BBasicColumn(
    {
      displayName: 'OCCURRENCE',
      enableSorting: false
    },
    {
      id: 'cron',
      sortProperty: 'entity.name',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.OCCURRENCE',
      concept: I4bCellConcept.SCHEDULERS,
      width: 140,
      isDefault: true,
      cell: {
        type: I4BCellType.CRON_READABLE_CELL
      }
    },
    { order: 5 }
  ),

  new TotalColumn(
    { displayName: 'TOTAL DEVICES', icon: 'device' },
    {
      id: 'devices.totalCount',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.TOTAL_DEVICES',
      concept: I4bCellConcept.SCHEDULERS,
      isDefault: true
    },
    { order: 6 }
  ),

  new I4BBasicColumn(
    {
      displayName: 'ENTITY NAME'
    },
    {
      id: 'entity.name',
      sortProperty: 'entity.name',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.ENTITY_NAME',
      concept: I4bCellConcept.SCHEDULERS,
      width: 140,
      isDefault: true
    },
    { order: 7 }
  ),
  new I4BBasicColumn(
    { displayName: 'TIMEZONE' },
    {
      id: 'timezone',
      isDefault: true,
      sortProperty: 'timezone',
      cell: { type: I4BCellType.BASIC },
      concept: I4bCellConcept.SCHEDULERS,
      autoSize: true
    },
    { order: 8 }
  ),
  new I4BBasicColumn(
    { displayName: 'LAST RUN' },
    {
      id: 'lastRun',
      isDefault: true,
      sortProperty: 'lastRun',
      cell: { type: I4BCellType.DATE },
      concept: I4bCellConcept.SCHEDULERS,
      autoSize: true
    },
    { order: 9 }
  ),
  new I4BBasicColumn(
    { displayName: 'NEXT RUN' },
    {
      id: 'nextRun',
      isDefault: true,
      sortProperty: 'nextRun',
      cell: { type: I4BCellType.DATE },
      concept: I4bCellConcept.SCHEDULERS,
      autoSize: true
    },
    { order: 10 }
  )
];

export class DefaultSchedulersGrid implements I4BGrid<I4BGridOptions, SchedulersGridData> {
  masterview = 'schedulers';
  isDefault = false;
  isUserDefault = false;
  isAppDefault = false;
  name = 'schedulers';
  userId = '';
  data: SchedulersGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: false },
    buttonColumn: { enabled: true, className: new I4BSchedulersButtonColumn() },
    gridSort: [{ colId: 'name', sort: 'asc', sortIndex: 0 }]
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = GET_DEFAULT_SCHEDULERS_COLUMNS_FOR_SCHEDULERS_VIEW();
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  export(): void {}
}
